import { DOCKET_ACCESS_REQUIREMENT_TYPE } from '../../common/utils/myDay/driverDaySteps';

const normalizeValue = value => (value || '').trim().replace(/\s+/g, ' ').toLowerCase();

/** Keep display order, but carry every original confirmation id on a shared item. */
export const groupAccessItems = (rows) => {
	const groups = new Map();
	return rows.map((row) => {
		const items = [];
		row.items.forEach((item) => {
			const tickKey = `${row.docket.id}:${item.id}`;
			const value = normalizeValue(item.value);
			const isSignIn = item.type === DOCKET_ACCESS_REQUIREMENT_TYPE.SIGN_IN;
			const siteId = row.docket.machine?.location?.id;
			// Unnamed passes remain separate; sign-in instructions only merge within a known site.
			const groupKey = isSignIn
				? JSON.stringify([item.type, siteId || row.docket.id, value])
				: value ? JSON.stringify([item.type, value]) : tickKey;
			const existing = groups.get(groupKey);
			if (existing) {
				existing.tickKeys.push(tickKey);
				if (!existing.stops.some(stop => stop.docket.id === row.docket.id)) {
					existing.stops.push({ docket: row.docket, stopNumber: row.stopNumber });
				}
			}
			else {
				const group = { ...item, tickKeys: [tickKey], stops: [{ docket: row.docket, stopNumber: row.stopNumber }] };
				groups.set(groupKey, group);
				items.push(group);
			}
		});
		return { ...row, items };
	}).filter(row => row.items.length > 0);
};
